import React from 'react';
import Layout from '../../components/Layout';

const ContactPage = () => {
  return (
    <Layout>
      <div className="py-12 max-w-5xl mx-auto">
        
        <h1 className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-blue-400 mb-4 text-center">
          Feedback & Support Channel
        </h1>
        <p className="text-lg text-gray-400 mb-10 text-center">
          Reach out with bug reports, feature requests, or technical inquiries about the MVP.
        </p>

        <div className="grid md:grid-cols-2 gap-12">
          
          {/* --- Contact Information Block --- */}
          <div className="bg-gray-800 p-8 rounded-xl shadow-2xl border border-teal-500/30">
            <h2 className="text-2xl font-semibold text-white mb-6">Direct Contact</h2>
            
            <div className="space-y-6">
              {/* Email */}
              <div>
                <p className="text-gray-400 text-sm uppercase tracking-wider mb-1">Email Support</p>
                <a 
                  href="mailto:support@decentralizeddev.com" 
                  className="text-teal-400 font-medium text-xl hover:text-teal-300 transition"
                >
                  support@decentralizeddev.com
                </a>
              </div>
              
              {/* Telegram/Discord Link */}
              <div>
                <p className="text-gray-400 text-sm uppercase tracking-wider mb-1">Community / Real-time Chat</p>
                <a 
                  href="#" // Replace with your actual link
                  className="text-indigo-400 font-medium text-xl hover:text-indigo-300 transition"
                >
                  Join Our Discord/Telegram
                </a>
              </div>
            </div>
          </div>

          {/* --- Feedback Form Block --- */}
          <div className="bg-gray-800 p-8 rounded-xl shadow-2xl border border-indigo-500/30">
            <h2 className="text-2xl font-semibold text-white mb-6">Submit Feedback</h2>

            <form className="space-y-4">
              {/* Name/Wallet Address */}
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-300">Your Name / Wallet ID (Optional)</label>
                <input 
                  type="text" 
                  id="name" 
                  className="mt-1 block w-full bg-gray-700 border-gray-600 rounded-md shadow-sm text-white focus:ring-teal-500 focus:border-teal-500 p-2"
                  placeholder="e.g., 0xABc...123 or John Doe"
                />
              </div>
              
              {/* Message */}
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-300">Message / Bug Report</label>
                <textarea 
                  id="message" 
                  rows="4" 
                  required
                  className="mt-1 block w-full bg-gray-700 border-gray-600 rounded-md shadow-sm text-white focus:ring-teal-500 focus:border-teal-500 p-2"
                  placeholder="Describe the issue or feature request here..."
                ></textarea>
              </div>

              {/* Submit Button */}
              <button 
                type="submit" 
                className="w-full py-3 mt-4 bg-teal-600 text-white font-bold rounded-lg hover:bg-teal-700 transition shadow-lg transform hover:scale-[1.01]"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;
